// extracted by mini-css-extract-plugin
export default {"form":"Onboarding_form__RIE+o","formInput":"Onboarding_formInput__gqhqy","infoText":"Onboarding_infoText__OCs-u","submitButton":"Onboarding_submitButton__N7p+O"};